<template>
    <div class="zone">
        <div class="container">
            <div class="text-center pt-5" v-if="httpLoading">
                <a-spin size="large" />
            </div>

            <div v-else-if="showWelcome" class="container bg-white py-5">
                <div class="title font-xl mb-4">{{ info.name }}</div>

                <img
                    class="cover-img"
                    :src="info.thumbnail | compressLarge"
                    alt=""
                />

                <div class="content mt-4 font-md">{{ info.details }}</div>

                <div class="text-right">
                    <span
                        class="text-primary font-xl more"
                        @click="showWelcome = false"
                        >详细信息</span
                    >
                    <a-icon
                        class="text-primary font-xl more"
                        @click="showWelcome = false"
                        type="double-right"
                    />
                </div>
            </div>

            <template v-else-if="info.title">
                <o-breadcrumb
                    :list="[{ path: '/city', text: '城市' }]"
                    :currentText="info.name"
                />
                <div class="bg-white p-4">
                    <user-status @update="update" />

                    <zone-pure-header
                        class="mb-3"
                        v-model="mode"
                        :info="info"
                        :show-back="true"
                        back-text="返回详情"
                        @view-large="viewImage"
                        @back="showWelcome = true"
                    />
                    <zone-slideshow
                        v-show="mode == 'slide'"
                        :active.sync="active"
                        :list="info.list"
                    />
                    <zone-listview v-show="mode == 'list'" :list="info.list" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import OBreadcrumb from "@/components/Breadcrumb"
import ZonePureHeader from "@/components/ZonePureHeader"
import ZoneSlideshow from "@/components/ZoneSlideshow"
import ZoneListview from "@/components/ZoneListview"
import { zones } from "@/config/navigations"
import { view } from "../store/preview"

export default {
    data() {
        return {
            info: {},
            mode: "slide",
            active: 0,
            showWelcome: true
        }
    },

    async created() {
        // this.$request(`/api/works/details/${this.$route.params.id}`, { middlewares: ['user'] })
        this.update()
    },

    methods: {
        viewImage() {
            const image = this.info.list[this.active]

            view(image.img)
        },
        async update() {
            const info = await this.$request(
                `/api/works/details/${this.$route.params.id}`,
                { middlewares: ["token"] }
            )

            this.info = {
                ...info,
                title: info.name,
                list: JSON.parse(info.medias)
            }
        }
    },

    components: { OBreadcrumb, ZonePureHeader, ZoneSlideshow, ZoneListview }
}
</script>

<style lang="scss" scoped>
.more {
    cursor: pointer;
}

.cover-img {
    width: 100%;
}
</style>